/* src/app.js */
/* eslint-disable */

// Styles
// import "../node_modules/bootstrap/scss/bootstrap.scss";
import "./assets/styles/main-ltr.scss";


//Scriptsbootstrap-slider.scss
import 'bootstrap';
import 'awesomplete';
import 'bootstrap-select/js/bootstrap-select'
// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/dropdown';
import Swiper from 'swiper';
// $(document).ready(() => {
require('./assets/scripts/mixitup.min');

require('./assets/scripts/custom');
require('./assets/scripts/forms');
require('./assets/scripts/footer');
require('./assets/scripts/swipers');
require('./assets/scripts/e-motion-validate');





if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
	require('./assets/scripts/smooth-scroll.js');
} else {
	require('./assets/scripts/SmoothScroll');

}

if ($('.validateForm').length) {
	require('./assets/scripts/jquery.validate.min.js');
	require('./assets/scripts/additional-method.js');
	let theactiveForm;

	let validateRules = {
		'bookingReference': {
			alphanumeric1: true,
			required: true,

		}
	}
	//https://www.codegrepper.com/code-examples/javascript/jquery+validate+form+before+submit
	//https://laracasts.com/discuss/channels/javascript/validate-form-served-via-ajax-call-using-jquery-validation
	//test from here
	function validateFormFun(el) {


		$(".validateForm").each(function () {


			$(this).validate({
				rules: validateRules,
				messages: roleMsgs,
				submitHandler: function (form) {
					if ($(form).find('.form_n_loader').length > 0) {
						$(form).find('.form_n_loader').removeClass('d-none');
					}
					$.ajax({
						url: form.action,
						type: form.method,
						data: $(form).serialize(),
						//start sucess
						success: function (response) {


							if (response.status == true) {
								console.log('response submitHandler', response, response.url);
								let respinseUrl = response.url;
								if (response.terms == true) {
									$('.termsModal').modal('show');
									$('.termsModal .msg').html(response.terms_msg);
									$(".termsModal").delegate(".agreeModal", "click", function () {
										window.open(respinseUrl, "_self");

									})

								} else {
									window.open(respinseUrl, "_self");

									// window.open(response.url);
								}

							} else {

								console.log('eror', response.status);
								var errors = response.messages;
								console.log('errors', errors);
								for (var i in errors) {
									//  console.log(' i', i);
									var output = '';
									var formGroup = $(form).find("[name='" + i + "']").parent('dev');
									var inputData = $(form).find("[name='" + i + "']");
									let inputId = $(inputData).attr("id");

									for (var j in errors[i]) {
										//    console.log('i',i);
										errors[i][j] = errors[i][j].replace("Value", i);
										errors[i][j] = errors[i][j].replace("The input", i);
										errors[i][j] = errors[i][j][0].toUpperCase() + errors[i][j].slice(1);
										output += "<label class='error' for='" + inputId + "'>" + errors[i][j] + "</label>";

									}

									$(inputData).addClass('error');

									$(output).insertAfter($(inputData));

								}


							} //end else

							if ($(form).find('.form_n_loader').length > 0) {
								$(form).find('.form_n_loader').addClass('d-none');
							}

						}
						//end sucess


					});
				}


			});
		})
	}



	validateFormFun($(".validateForm"));


	//end my validation

	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		if ($(".tab-pane.active  .validateForm").length > 0) {
			validateFormFun($(".tab-pane.active  .validateForm"));



		}
	})

}
if (($('.route-map .controls').length > 0) || ($('.route-map .controls').length > 0)) {
	require('./assets/scripts/awesomplete');

}

if ($('.bookingForms').length > 0) {

	require('./assets/scripts/NewBooking');
}
if ($('.route-map .controls').length > 0) {

	require('./assets/scripts/routeMap');
}
if ($('.innerNav').length) {
	require('./assets/scripts/innerNav');
}




require('./assets/scripts/photoswipe-lightbox.esm');
require('./assets/scripts/photoswipe.esm');
require('./assets/scripts/photoswipecustom');

// });
